import { render } from "./icon_arrow_bottom_left.svg?vue&type=template&id=2baef860"
const script = {}

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__